/*
 * VULCAN
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/statusPagesMappers";
/** Class representing a StatusPages. */
var StatusPages = /** @class */ (function () {
    /**
     * Create a StatusPages.
     * @param {PortalContext} client Reference to the service client.
     */
    function StatusPages(client) {
        this.client = client;
    }
    StatusPages.prototype.getStatusPageComponents = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getStatusPageComponentsOperationSpec, callback);
    };
    StatusPages.prototype.getStatusPageStatusSummary = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getStatusPageStatusSummaryOperationSpec, callback);
    };
    return StatusPages;
}());
export { StatusPages };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getStatusPageComponentsOperationSpec = {
    httpMethod: "GET",
    path: "latest/api/v1/statuspages/components",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StatusPageComponentResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getStatusPageStatusSummaryOperationSpec = {
    httpMethod: "GET",
    path: "latest/api/v1/statuspages/statusSummary",
    responses: {
        200: {
            bodyMapper: Mappers.StatusPageStatusSummaryResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=statusPages.js.map